import { selectComments, selectCommentsList } from '../selectors/comments';

import { useAppSelector } from './redux';

export const useCommentsList = () => useAppSelector(selectCommentsList);
export const useComments = () => useAppSelector(selectComments);
